import { useEffect, useState } from "react";
import { MdVisibility } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { Request, RequestsProps } from "../../../../@types/requests";
import Loading from "../../../../Components/Loading";
import Paginate from "../../../../Components/Paginate";
import Status from "../../../../Components/Status";
import { useStateValue } from '../../../../providers/StateProvider';
import { getRequestForStatus } from "../../../../services/requests";
import { cpfMask } from "../../../../utils/cpfFormat";
import dateFormat from "../../../../utils/dateFormat";
import { CardFooterCustom, CustomTable, NoFoundData } from "../../styles";
import { ModalPermission } from '../ModalPermission';
import StatusRequest from "../StatusRequest";
import { CustomButton } from "./styles";

type Props = {
	isSearch: boolean;
	filter: string;
	dataInicial: any;
	dataFinal: any;
	search: string;
	status:
	| "Aguardando"
	| "Solicitado"
	| "Em Andamento"
	| "Finalizado"
	| "Cancelado"
	| "Restituído"
	| "Encaminhado";
};

type CheckPermissionToChangeRequest = {
	attendantCpf: string
	data: Request
}

const RequestsList = ({
	status,
	isSearch,
	filter,
	search,
	dataInicial,
	dataFinal,
}: Props): JSX.Element => {
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [{ user }] = useStateValue();
	const [requestList, setRequestList] = useState<RequestsProps | undefined>(
		undefined
	);
	const [requestData, setRequestData] = useState<Request>()
	const [openModalPermission, setOpenModalPermisision] = useState(false)

	const getRequest = async ({ page }: { page: number | 1 }) => {
		setLoading(true);
		setRequestList(undefined);
		try {
			let params = {
				page,
			};

			if (filter.length && search.length) {
				params["filtro"] = filter;
				if (filter === "cpf") {
					//   alert("CPF filter");
					params["busca"] = search.replace(/\D/g, "");
				} else {
					params["busca"] = search;
				}
			}

			if (filter === "data") {
				params["filtro"] = filter;
				params["data_inicio"] = dataInicial;
				params["data_fim"] = dataFinal;
			}

			const { data } = await getRequestForStatus(status, params);
			setRequestList(data);
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getRequest({ page: 1 });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		getRequest({ page: 1 });

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSearch]);

	const compareDates = (dateString: string): boolean =>  {
		const parts = dateString.split('/');

    const providedDate = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0])).getTime();

		if(providedDate){
			const { year, month, day } = {
				year: new Date().getFullYear(),
				month:  new Date().getMonth(),
				day:  new Date().getDate()
			}
	
			const currentDate = new Date(year, month, day).getTime();
	
			return currentDate > providedDate;
		}  

		return false

	}

	const handleOpenModalPermission = () => {
		setOpenModalPermisision(state => !state)
	}

	const checkPermissionToChangeRequest = ({ attendantCpf, data }: CheckPermissionToChangeRequest) => {
		if(status === 'Em Andamento' || status === 'Restituído'){
			if(attendantCpf !== user.cpf){
				setRequestData(data)
				setOpenModalPermisision(true)
			} else {
				setRequestData(undefined)
				setOpenModalPermisision(false)

				history.push(
					`/solicitacoes/detalhes/${data?.identificador}`
				);
				
			}
		} else {
			setRequestData(undefined)
			setOpenModalPermisision(false)

			history.push(
				`/solicitacoes/detalhes/${data?.identificador}`
			);
		}

	}

	return (
		<>
			{loading && <Loading />}

			{requestList && requestList.results.length > 0 ? (
				<CustomTable responsive>
					<thead className="table-header">
						<tr>
							<th>#</th>
							<th>Situação</th>
							<th>Protocolo</th>
							<th>Assinado</th>
							<th>Solicitado por</th>
							<th>Órgão/Setor</th>
							<th>Serviço</th>
							<th>Prazo</th>
							<th>Atendente</th>
							<th>Atualizado em</th>
							<th>Ações</th>
						</tr>
					</thead>
					<tbody className="table-body">
						{requestList.results.map((request, index) => {
							const firstName = status !== "Solicitado"
								? (request.historico_flow_resposta?.map((item) => item?.user?.first_name).filter(Boolean)[0] || "Não consta")
								: (request.documento_resposta[0]?.user?.first_name || "Não consta");

							const responseDeadline = request?.prazo_resposta ? compareDates(request?.prazo_resposta) : null
							const backgroundColor = responseDeadline && "#ffdcd9"

							return (
								<>
								
									<tr key={request.identificador} style={{ backgroundColor }}>
									<td>{index + 1}</td>
									<td>
										<StatusRequest type={request.status} />
									</td>
									<td>{request.protocolo}</td>
									<td>
										<Status type={request.concluido.toString()} />
									</td>
									<td>{cpfMask(request.cpf)}</td>
									<td>
										{request?.setor ? (
											<>
												{`${request?.setor?.orgao?.sigla} / ${request?.setor.sigla}`}
											</>
										) : (
											<>
												{request?.orgao?.sigla}
											</>
										)}
									</td>
									<td>{request.servico_titulo ? request.servico_titulo : 'Não Consta'}</td>
									<td>{request?.prazo_resposta ? request?.prazo_resposta : 'Sem prazo'}</td>
									<td>{request?.atendente?.first_name ?? firstName}</td>
									<td>{dateFormat(request.updated_at, true)}</td>
									<td>
										<CustomButton
											variant="outline-secondary"
											onClick={() =>  {
												checkPermissionToChangeRequest({ 
													attendantCpf: request?.atendente?.username,
													data: request,
												})
											}}
										>
											<MdVisibility size={20} className="icon" />
										</CustomButton>
									</td>
								</tr>
								</>
							)
						})}
					</tbody>
				</CustomTable>
			) : (
				<>{!loading && <NoFoundData>Sem resultados!</NoFoundData>}</>
			)}
			{requestList?.results?.length > 0 && (
				<CardFooterCustom>
					<Paginate
						flowData={requestList}
						setPage={getRequest}
						page={requestList?.current}
					/>
				</CardFooterCustom>
			)}
				<ModalPermission 
					open={openModalPermission} 
					onOpen={handleOpenModalPermission} 
					request={requestData} />
			{/* {!!requestData && !!requestData?.id && (
			)} */}
		</>
	);
};

export default RequestsList;
